<template>
  <div class="body">
    <el-card class="box_card">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="修改登录密码" name="loginpassword">
          <div class="tabpane_content">
            <div class="login_content">
              <div class="login_title">修改登录密码</div>
              <div class="login_tips">【新密码规则】 必须是由大写字母，小写字母，数字，以及特殊字符[@_.\-#$%!]组成，且长度不少于8位；</div>
              <div class="login_form">
                <el-form :model="ruleForm" :rules="rules" status-icon ref="ruleForm" size="medium" label-width="100px"
                  class="demo-ruleForm">
                  <el-form-item label="旧密码" prop="oldPass">
                    <el-input :type="oldPassType" v-model="ruleForm.oldPass" autocomplete="off">
                      <i slot="suffix" v-if="oldPassType !== 'password'" class="el-input__icon iconfont iconzhengyan"
                        style="cursor: pointer; font-size: 20px; color: #2d99d7" @click="showOldPwd"></i>
                      <i slot="suffix" v-if="oldPassType === 'password'" class="el-input__icon iconfont iconbiyan1"
                        style="cursor: pointer; font-size: 20px" @click="showOldPwd"></i>
                    </el-input>
                  </el-form-item>
                  <!-- <el-form-item label="验证码" prop="code">
                    <el-input v-model="ruleForm.code" autocomplete="off" style="width:160px;"></el-input>
                    <el-button type="primary" round>获取验证码</el-button>
                  </el-form-item> -->
                  <el-form-item label="新密码" prop="pass">
                    <el-input :type="passwordType" v-model="ruleForm.pass" autocomplete="off">
                      <i slot="suffix" v-if="passwordType !== 'password'" class="el-input__icon iconfont iconzhengyan"
                        style="cursor: pointer; font-size: 20px; color: #2d99d7" @click="showPwd"></i>
                      <i slot="suffix" v-if="passwordType === 'password'" class="el-input__icon iconfont iconbiyan1"
                        style="cursor: pointer; font-size: 20px" @click="showPwd"></i>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="确认新密码" prop="checkPass">
                    <el-input :type="checkPasswordType" v-model="ruleForm.checkPass">
                      <i slot="suffix" v-if="checkPasswordType !== 'password'"
                        class="el-input__icon iconfont iconzhengyan"
                        style="cursor: pointer; font-size: 20px; color: #2d99d7" @click="showPwdCheck"></i>
                      <i slot="suffix" v-if="checkPasswordType === 'password'" class="el-input__icon iconfont iconbiyan1"
                        style="cursor: pointer; font-size: 20px" @click="showPwdCheck"></i>
                    </el-input>
                  </el-form-item>
                  <el-form-item class="bottom_form">
                    <el-button type="primary" round style="width: 280px" @click="submitForm('ruleForm')"> 确认</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="设置支付密码" name="paymentpassword">
          <div class="tabpane_content">
            <div class="login_content">
              <div class="login_title">设置密码</div>
              <div class="login_form">
                <div class="form_title">{{ payPasswordTitle }}</div>
                <div class="form_passwordbox">
                  <password-input ref="passInpt" @retrun="getPassword"></password-input>
                </div>
                <div class="form_passwordbox">
                  <el-button type="primary" round style="height: 40px; width: 280px" @click="confirmPayPassword"> 确认</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane> -->
        <!-- <el-tab-pane label="免密设置" name="secretfree">
          <div class="tabpane_content">
            <div class="login_content">
              <div class="login_title">免密设置</div>
              <div class="login_form">
                <div class="form_title2" style="margin: 0 0 15px 40px">是否开启免密：</div>
                <div class="form_title" style="margin-bottom: 30px">
                  <el-switch v-model="isOpen" active-text="开启" inactive-text="关闭" @change="openSecretfree"> </el-switch>
                </div>
                <div class="form_title2" style="margin: 0 0 15px 40px" v-if="isOpen">设置免密额度：</div>
                <div class="form_title" v-if="isOpen">
                  <el-input placeholder="请输入免密金额：" v-model="input1" style="width: 280px">
                    <template slot="append"> 元</template>
                  </el-input>
                </div>
                <div class="form_title2" style="margin: 30px 0 15px 40px">输入支付密码：</div>
                <div class="form_passwordbox" style="margin-top: 0px">
                  <password-input></password-input>
                </div>
                <div class="form_passwordbox">
                  <el-button type="primary" round style="height: 40px; width: 280px"> 确认</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane> -->
        <el-tab-pane label="意见反馈" name="feedback">
          <div class="tabpane_content">
            <div class="login_feedback">
              <div class="login_title">意见反馈</div>
              <div class="login_form">
                <div class="form_title">
                  <div class="title_span"><span style="color: red">*</span>问题类型 ：</div>
                  <div style="width: 100%">
                    <el-select v-model="suggestValue" placeholder="请选择异常类型">
                      <el-option v-for="item in suggestOptions" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="form_title">
                  <div class="title_span"><span style="color: red">*</span>问题与建议：</div>
                  <div style="width: 100%">
                    <el-input type="textarea" :rows="4" placeholder="请输入你的问题与建议" v-model="suggestText"
                      style="width: 100%">
                    </el-input>
                  </div>
                </div>
                <div class="form_title">
                  <div class="title_span">上传照片：</div>
                  <div style="width: 100%">
                    <el-upload ref="my-upload" action="#" :http-request="httpRequest" list-type="picture-card" :limit="3"
                      :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-change="handleChange"
                      :auto-upload="false">
                      <i class="el-icon-plus"></i>
                      <div slot="tip" class="el-upload__tip">截图最多上传3张，且每张不可超过2M</div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt="" />
                    </el-dialog>
                  </div>
                </div>

                <div class="form_passwordbox">
                  <el-button type="primary" round style="height: 40px; width: 280px" @click="confirmSuggest">
                    确认</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request';
import passwordInput from '../../common/passwordInput';
import { uploadImage } from '../../../api/index';

export default {
  name: 'ResetIndex',
  components: {
    passwordInput
  },
  data() {
    var checkphone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入手机号'));
      } else if (!this.isCellPhone(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error('输入手机号格式错误!'));
      } else {
        callback();
      }
    };
    var checknewpass = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入新密码'));
      } else if (!this.checkedPassWordDreg(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error('新密码不符合规则，请重新根据规则输入;'));
      } else {
        callback();
      }
    };
    var checknewpass2 = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次新密码输入不一致，请重新检查后输入;'));
      } else if (!this.checkedPassWordDreg(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error('新密码不符合规则，请重新根据规则输入;'));
      } else {
        callback();
      }
    };
    return {
      uploadImageList: [], //最终上传图片地址
      fileList: [], //组件imageList
      dialogImageUrl: '',
      dialogVisible: false,
      suggestValue: '', //问题类型
      suggestText: '', //富文本
      suggestOptions: [
        {
          value: '功能异常或不可使用',
          label: '功能异常或不可使用'
        },
        {
          value: '用的不爽，我有意见',
          label: '用的不爽，我有意见'
        },
        {
          value: '功能不足，我有想法',
          label: '功能不足，我有想法'
        }
      ],
      isOpen: false, //是否开启免密支付
      input1: '',
      activeName: '',
      checked: false,
      oldPassType: 'password',
      checkPasswordType: 'password',
      passwordType: 'password',
      ruleForm: {
        oldPass: '',
        pass: '',
        checkPass: ''
      },
      rules: {
        oldPass: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        pass: [{ required: true, validator: checknewpass, trigger: 'blur' }],
        checkPass: [{ required: true, validator: checknewpass2, trigger: 'blur' }]
      },
      payPasswordTitle: '请设置支付密码',
      isPassExist: false,
      payPasswordFirst: '',
      oldPayPassWord: '',
      newPayPassWord: ''
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.activeName = val.query.word;
      },
      deep: true
    }
  },
  created() {
    this.clinicInfo = JSON.parse(sessionStorage.user);
    this.getPasswordStatus();
  },
  mounted() {
    var vm = this;
    this.activeName = this.$route.query.word;
  },
  methods: {
    // 校验新密码
    checkedPassWordDreg(value) {
      const passwordreg = /^(?=.{8})(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[_.\-#$%!@]).*$/;
      const isValid = passwordreg.test(value);
      if (isValid !== true) {
        return false
      } else {
        return true
      }
    },
    //---------- 意见反馈模块-------
    httpRequest(data) {
      // let _this = this;
      // let rd = new FileReader(); // 创建文件读取对象
      // let file = data.file;
      // rd.readAsDataURL(file); // 文件读取装换为base64类型
      // rd.onloadend = function (e) {
      //   _this.dialogImageUrl = this.result; // this指向当前方法onloadend的作用域
      // };
    },
    // 删除图片
    handleRemove(file) {
      const index = this.fileList.findIndex((x) => x.uid === file.uid);
      this.uploadImageList.splice(index, 1);
      this.fileList.splice(index, 1);
    },
    //上传图片
    handleChange(file, fileList) {
      const that = this;
      const isImg = file.size / 1024 / 1024 < 2;
      if (!isImg) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      let formdata = new FormData();
      formdata.append('file', file.raw);
      formdata.append('type', file.raw.type);
      uploadImage(formdata).then((res) => {
        if (res.success) {
          that.$message.success('图片选择成功');
          that.fileList.push(file);
          that.uploadImageList.push(res.data);
        } else {
          that.$message.error('图片选择失败，请删除后重新上传');
        }
      });
    },
    // 放大图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 意见反馈提交
    confirmSuggest() {
      const that = this;
      if (!that.suggestValue) {
        that.$message.warning('请先选择问题类型,再提交');
        return false;
      }
      if (!that.suggestText) {
        that.$message.warning('请先输入建议,再提交');
        return false;
      }
      let dataP = {
        id: null,
        cal_code: that.clinicInfo.hsp_code,
        cal_name: that.clinicInfo.hsp_name,
        cafb_Question_type: that.suggestValue,
        cafb_Problems_and_suggestions: that.suggestText,
        cafb_Question_picture: '',
        cafb_producer: that.clinicInfo.sysuser,
        cafb_Producer_ID: that.clinicInfo.Operatoridentity
      };
      const params = {
        token: that.clinicInfo.token,
        datatab: '8386e1Ji3Fdb8J+osCHCuowPrVkuAbwbVGc+RdQe3soRqiypDw+C2U3RAf+S', //对应表名
        select: 'b8daANMOam1NrUxKTR925+rySVozx1cnd0uIFW5N', //需要字段的名字
        obgb: 'e0011nvCMxt2TF08EbnaK1afxhxqltaubjvES7mn1rJZXuiZgogmG4F+Hy+S07/7Ag', //不动
        LIKE: 'nl',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/setkehuzlapi.php', params)
        .then((res) => {
          if (res.IsOk === 'success') {
            that.$message.success('恭喜，意见反馈提交成功');
            that.suggestValue = '';
            that.suggestText = '';
            that.uploadImageList = [];
            that.fileList = [];
            this.$refs['my-upload'].clearFiles();
          } else {
            that.$message.error('抱歉，意见反馈提交失败');
          }
        })
        .catch((err) => {
          that.$message.error('抱歉，意见反馈提交失败');
        });
    },
    //---------- 支付密码模块-------
    //设置支付密码
    confirmPayPassword() {
      if (this.payPasswordTitle === '请设置支付密码') {
        if (this.payPasswordFirst.length !== 6) {
          this.$message.error('请输入6位支付密码');
          return false;
        }
        this.setPassWordFirst(this.payPasswordFirst);
      } else if (this.payPasswordTitle === '请输入旧支付密码') {
        if (this.oldPayPassWord.length !== 6) {
          this.$message.error('请输入6位旧支付密码');
          return false;
        }
        this.checkOldPassword(this.oldPayPassWord);
      } else if (this.payPasswordTitle === '请输入新支付密码') {
        if (this.newPayPassWord.length !== 6) {
          this.$message.error('请输入6位新支付密码');
          return false;
        }
        this.setNewPayPassWord(this.newPayPassWord);
      }
    },
    // 第一次设置新密码
    setPassWordFirst(val) {
      const that = this;
      const params = {
        token: that.clinicInfo.token,
        ywbh: 'PAYpasswork',
        hsp_code: that.clinicInfo.hsp_code,
        hsp_name: that.clinicInfo.hsp_name,
        sysuser: that.clinicInfo.sysuser,
        Operatoridentity: that.clinicInfo.Operatoridentity,
        syspassold: '',
        syspassnew: val,
        syspassnew1: val
      };
      request
        .post('/server/Channelloginfo.php', params)
        .then((res) => {
          if (res.IsOk == 'success') {
            that.$message.success('恭喜,支付密码设置成功');
            that.$refs.passInpt.reset();
            that.payPasswordTitle = '请输入旧支付密码';
          } else {
            that.$message.error('抱歉，密码设置失败,请重新输入');
            that.$refs.passInpt.reset();
          }
        })
        .catch((err) => {
          that.$message.error('抱歉，密码设置失败,请重新输入');
        });
    },
    //校验旧的支付密码
    checkOldPassword(val) {
      const that = this;
      const params = {
        token: that.clinicInfo.token,
        ywbh: 'CKpasswork',
        hsp_code: that.clinicInfo.hsp_code,
        hsp_name: that.clinicInfo.hsp_name,
        sysuser: that.clinicInfo.sysuser,
        Operatoridentity: that.clinicInfo.Operatoridentity,
        syspassold: val
      };
      request
        .post('/server/Channelloginfo.php', params)
        .then((res) => {
          if (res.IsOk == 'success') {
            that.$message.success('恭喜,旧密码检验成功,请输入新的支付密码');
            that.payPasswordTitle = '请输入新支付密码';
            that.$refs.passInpt.reset();
          } else {
            that.$message.error('抱歉，旧密码检验失败,请重新输入');
            that.$refs.passInpt.reset();
          }
        })
        .catch((err) => {
          that.$message.error('抱歉，旧密码检验失败,请重新输入');
          that.$refs.passInpt.reset();
        });
    },
    //设置新的支付密码
    setNewPayPassWord(val) {
      const that = this;
      const params = {
        token: that.clinicInfo.token,
        ywbh: 'PAYpasswork',
        hsp_code: that.clinicInfo.hsp_code,
        hsp_name: that.clinicInfo.hsp_name,
        sysuser: that.clinicInfo.sysuser,
        Operatoridentity: that.clinicInfo.Operatoridentity,
        syspassold: that.oldPayPassWord,
        syspassnew: val,
        syspassnew1: val
      };
      request
        .post('/server/Channelloginfo.php', params)
        .then((res) => {
          if (res.IsOk == 'success') {
            that.$message.success('恭喜,新密码设置成功');
            that.$refs.passInpt.reset();
            that.oldPayPassWord = '';
            that.newPayPassWord = '';
            that.payPasswordTitle = '请输入旧支付密码';
          } else {
            that.$message.error('抱歉，新密码设置失败,请重新输入');
            that.$refs.passInpt.reset();
          }
        })
        .catch((err) => {
          that.$message.error('抱歉，新密码设置失败,请重新输入');
        });
    },

    //获取支付密码（子组件）
    getPassword(val) {
      if (this.payPasswordTitle === '请设置支付密码') {
        this.payPasswordFirst = val;
      } else if (this.payPasswordTitle === '请输入旧支付密码') {
        this.oldPayPassWord = val;
      } else if (this.payPasswordTitle === '请输入新支付密码') {
        this.newPayPassWord = val;
      }
    },
    // 选项切换
    handleClick(tab, event) {
      if (tab.name === 'paymentpassword') {
        this.getPasswordStatus();
      }
    },
    // 获取支付密码是否已设置
    getPasswordStatus() {
      const that = this;
      let dataP = {
        cal_code: that.clinicInfo.cal_code
      };
      const params = {
        token: that.clinicInfo.token,
        workid: 'cf45cc33-8aff-493d-f048-e723acbb91d4',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          if (res.length) {
            that.isPassExist = false; //密码未设置
            that.payPasswordTitle = '请设置支付密码';
          } else {
            that.payPasswordTitle = '请输入旧支付密码';
            that.isPassExist = true; //密码已存在
          }
        })
        .catch((err) => { });
    },

    //---------- 登录密码模块-------
    //检查手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    showOldPwd() {
      if (this.oldPassType === 'password') {
        this.oldPassType = '';
      } else {
        this.oldPassType = 'password';
      }
    },
    showPwdCheck() {
      if (this.checkPasswordType === 'password') {
        this.checkPasswordType = '';
      } else {
        this.checkPasswordType = 'password';
      }
    },
    showPwdCheck() {
      if (this.checkPasswordType === 'password') {
        this.checkPasswordType = '';
      } else {
        this.checkPasswordType = 'password';
      }
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
    },
    remberPassword(val) {
      console.log(val);
    },
    // 确认设置密码
    submitForm() {
      const that = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (that.ruleForm.pass !== that.ruleForm.checkPass) {
            that.$message.error('抱歉,新密码两次输入不一致，请重新输入');
            return false;
          }
          let params = {
            operatoridentity: that.clinicInfo.Operatoridentity,
            sysuser: that.clinicInfo.sysuser,
            calCode: that.clinicInfo.cal_code,
            userid: that.clinicInfo.userid,
            syspassold: that.ruleForm.oldPass,
            syspassnew: that.ruleForm.pass,
            syspassnew1: that.ruleForm.checkPass,
          };
          request
            .post('/login/checkPassSingleByTheAccount', params, { category: 'XuXiZhi' })
            .then((res) => {             
              if (res.success) {
                that.changePassword();//更换密码
              } else {
                that.$message.error(res.errMsg ? res.errMsg : "修改出错请联系管理员;");
              }
            })
        } else {
          return false;
        }
      });
    },
    // 更换密码
    changePassword() {
      const that = this;
      const params = {
        token: that.clinicInfo.token,
        ywbh: 'passwork',
        hsp_code: that.clinicInfo.hsp_code,
        hsp_name: that.clinicInfo.hsp_name,
        sysuser: that.clinicInfo.sysuser,
        Operatoridentity: that.clinicInfo.Operatoridentity,
        syspassold: that.ruleForm.oldPass,
        syspassnew: that.ruleForm.pass,
        syspassnew1: that.ruleForm.checkPass
      };
      request
        .post('/server/Channelloginfo.php', params)
        .then((res) => {
          if (res.IsOk == 'success') {
            that.$message.success('恭喜，设置成功，请重新登录');
            that.$router.push({ path: '/login', query: { name: '111' } });
          } else {
            that.$message.error('抱歉，旧密码输入错误，请重新输入;');
          }
        })
    }
  }
};
</script>

<style lang="scss" scoped>
.body {
  width: 100%;
  height: 100%;

  .box_card {
    height: 99%;
    // border: 1px solid rgb(53, 233, 8);
    margin-right: 30px;
    box-sizing: border-box;

    ::v-deep .el-card__body {
      height: 100%;
    }

    ::v-deep .el-card {
      height: 100%;
    }

   ::v-deep .el-tabs {
      height: 100%;
    }

    ::v-deep .el-tabs__content {
      height: 100%;
    }

    ::v-deep .el-tab-pane {
      height: 100%;
    }

    .tabpane_content {
      width: 100%;
      height: 90%;
      // border: 1px solid darkgoldenrod;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;

      //意见反馈
      .login_feedback {
        width: 990px;
        min-height: 500px;
        background: #ffffff;
        box-shadow: 0px 5px 50px 0px rgba(186, 186, 186, 0.5);
        border-radius: 35px;
        padding: 30px;
        // border: 1px solid red;
        overflow-y: auto;
        box-sizing: border-box;

        ::v-deep .el-upload--picture-card {
          width: 108px;
          height: 108px;
          line-height: 108px;
        }

        .login_title {
          width: 100%;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #2d99d7;
          text-align: center;
          border-bottom: 1px solid #f0f0f0;
          padding-bottom: 30px;
        }

        .login_form {
          width: 600px;
          height: auto;
          box-sizing: border-box;
          // border: 1px solid red;
          margin: 30px auto;

          .form_passwordbox {
            width: 100%;
            display: flex;
            justify-content: center;
          }

          .form_title {
            display: flex;
            justify-content: flex-start;
            margin-bottom: 30px;

            .title_span {
              width: 120px;
              font-size: 15px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              text-align: left;
              // border: 1px solid red;
            }
          }

          ::v-deep .el-input--medium .el-input__inner {
            height: 45px !important;
            line-height: 45px !important;
            // border-radius: 0 10px 10px 0;
          }

          ::v-deep .el-button--medium {
            height: 45px !important;
            margin-left: 10px;
          }
        }
      }

      // 其他三模块
      .login_content {
        width: 990px;
        height: 500px;
        background: #ffffff;
        box-shadow: 0px 5px 50px 0px rgba(186, 186, 186, 0.5);
        border-radius: 35px;
        padding: 30px 30px;

        .reset_success {
          width: 120px;
          height: 200px;
          margin: 100px auto;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;

          .success_text {
            width: 100%;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 600;
            color: #333333;
            text-align: center;
          }
        }

        .login_title {
          width: 100%;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #2d99d7;
          text-align: center;
          border-bottom: 1px solid #f0f0f0;
          padding-bottom: 30px;
        }

        .login_tips {
          width: 100%;
          font-size: 14px;
          color: red;
          text-align: center;
          margin-top: 5px;
        }

        .login_form {
          width: 400px;
          height: 320px;
          box-sizing: border-box;
          // border: 1px solid red;
          margin: 30px auto;

          .form_title {
            font-size: 20px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            text-align: center;

            ::v-deep .el-input__inner {
              height: 40px;
            }
          }

          .form_title2 {
            font-size: 15px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            text-align: left;
          }

          .form_passwordbox {
            display: flex;
            justify-content: center;
            margin-top: 50px;
          }

          ::v-deep .el-input--medium .el-input__inner {
            height: 45px !important;
            line-height: 45px !important;
            // border-radius: 0 10px 10px 0;
          }

          ::v-deep .el-button--medium {
            height: 45px !important;
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>
